import { render, staticRenderFns } from "./FormErrorPage.vue?vue&type=template&id=1fe7154e&scoped=true"
import script from "./FormErrorPage.vue?vue&type=script&lang=ts"
export * from "./FormErrorPage.vue?vue&type=script&lang=ts"
import style0 from "./FormErrorPage.vue?vue&type=style&index=0&id=1fe7154e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7154e",
  null
  
)

export default component.exports